import React from 'react';
import Paper from '@mui/material/Paper';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { ZIPCODE_MAP_VIEW_TABS } from './zipcodeMapConfig';

export default function ZipcodeMapViewModeToolbar({ mapViewMode, onMapViewModeChange }) {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: '12px',
        boxShadow: '0 8px 32px rgba(15, 23, 42, 0.18)',
        overflow: 'hidden',
        pointerEvents: 'auto',
        width: '100%',
      }}
    >
      <ToggleButtonGroup
        exclusive
        fullWidth
        size="small"
        value={mapViewMode}
        onChange={(_, value) => value && onMapViewModeChange(value)}
        sx={{
          '& .MuiToggleButton-root': {
            textTransform: 'none',
            fontFamily: 'Inter Regular, sans-serif',
            fontSize: 11.5,
            py: 0.75,
            px: 0.5,
            borderColor: '#D7E0F2',
            color: '#3F3F6E',
            flex: 1,
            '&.Mui-selected': {
              bgcolor: '#fdeee7',
              color: '#3F3F6E',
              fontFamily: 'Inter Bold, sans-serif',
              fontWeight: 700,
            },
          },
        }}
      >
        {ZIPCODE_MAP_VIEW_TABS.map((tab) => (
          <ToggleButton key={tab.id} value={tab.id}>
            {tab.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Paper>
  );
}
